import styled from 'styled-components';

const IconColumn = styled.div`
  align-items: center;
  display: flex;
  flex-basis: 32px;
  justify-content: center;
`;

export default IconColumn;
